import React, { useCallback, useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import { pure } from "recompose";
import classnames from "classnames";
import { defineMessages, FormattedDate, FormattedMessage } from "react-intl";
import styles from "./PaymentForm.scss";
import {
  CCForm,
  GuaranteeMessage,
  PCIProxy,
  PayNoPainV2BridgeWrapper,
  Deferred,
} from "~/components";
import constants from "../../utils/constants";
import Notification from "~/components/Notification/Notification";
import { renderHTML } from "../../utils/misc";
import comodoSecureURL from "../../theme/payments/comodo_secure.png";
import pciURL from "../../theme/payments/pci.png";
import { creditCardIcons, Lock2Icon } from "../../theme/assets";
import { Conditions, PopupPrivacy, ReservationTotalAmount } from "@witbooking/react-components";
import moment from "moment";
import momentDurationFormatSetup from "moment-duration-format";
momentDurationFormatSetup(moment);
import styled from "styled-components";
import { wbRed } from "../../theme/variables";
import RowWithHeader from "../ReservationConfirmed/RowWithHeader";

const msgs = defineMessages({
  paymentOptions: {
    id: "checkout.payment_form.paymentOptions",
    description: "paymentOptions",
    defaultMessage: "Payment options",
  },
  STRIPE: {
    id: "checkout.payment_form.creditCardGuarantee",
    description: "Stripe",
    defaultMessage: "Credit card (online payment)",
  },
  stripeDescription: {
    id: "checkout.payment_form.stripe",
    description: "Stripe",
    defaultMessage: "Pay with Stripe",
  },
  PAYPAL_EXPRESS_CHECKOUT: {
    id: "checkout.payment_form.paypal_ec",
    description: "Paypal EC",
    defaultMessage: "Paypal",
  },
  paypalECDescription: {
    id: "checkout.payment_form.payPal",
    description: "Stripe",
    defaultMessage: "Pay with Paypal",
  },
  CREDIT_CARD_VAULT_EMERGENT: {
    id: "checkout.payment_form.creditCardGuarantee",
    description: "creditCardGuarantee",
    defaultMessage: "Credit card as guarantee",
  },
  PCI_PROXY: {
    id: "checkout.payment_form.creditCardGuarantee",
    description: "creditCardGuarantee",
    defaultMessage: "Credit card as guarantee",
  },
  CREDIT_CARD_VAULT: {
    id: "checkout.payment_form.creditCardGuarantee",
    description: "creditCardGuarantee",
    defaultMessage: "Credit card as guarantee",
  },
  SIPAY_TOKENIZED_VAULT: {
    id: "checkout.payment_form.creditCardGuarantee",
    description: "creditCardGuarantee",
    defaultMessage: "Credit card as guarantee",
  },
  SIPAY_TOKENIZED_POS: {
    id: "checkout.payment_form.tpvtoken",
    description: "tpv payment ",
    defaultMessage: "Credit card (online payment)",
  },
  POS: {
    id: "checkout.payment_form.tpv",
    description: "tpv payment ",
    defaultMessage: "Credit card (online payment)",
  },
  ADDON_PAYMENTS: {
    id: "checkout.payment_form.addon_payments",
    description: "addon payment ",
    defaultMessage: "Credit card (online payment)",
  },
  TRANSFER: {
    id: "checkout.payment_form.tr",
    description: "wire transfer payment ",
    defaultMessage: "Wire Transfer ",
  },
  WITHOUT_CARD: {
    id: "checkout.payment_form.book_withoutCard",
    description: "Book without credit card",
    defaultMessage: "Book without credit card",
  },
  RESERVATION_REQUEST: {
    id: "checkout.payment_form.reservationRequest",
    description: "Booking request",
    defaultMessage: "Booking request",
  },
  transfer: {
    id: "checkout.payment_form.transfer",
    description: "Transfer",
    defaultMessage: "Transfer",
  },
  reservationRequest: {
    id: "checkout.payment_form.reservationRequest",
    description: "Booking request",
    defaultMessage: "Booking request",
  },
  trTimeLimit: {
    id: "checkout.payment_form.tr_time_limit",
    description: "wire transfer time limit ",
    defaultMessage: "Time Limit",
  },
  trBookingRelease: {
    id: "checkout.payment_form.trBookingRelease",
    description: "wire transfer Booking Release ",
    defaultMessage: "Your booking will be released after the deadline.",
  },
  trBookingInstructions: {
    id: "checkout.payment_form.trBookingInstructions",
    description: "wire transfer Booking instructions ",
    defaultMessage: "You will receive instructions in your email.",
  },
  hours: {
    id: "checkout.payment_form.hours",
    description: "hours ",
    defaultMessage: "hours ",
  },
  termsAndConditions: {
    id: "checkout.payment_form.termsAndConditions",
    description: "I accept the terms and conditions",
    defaultMessage: "I accept the terms and conditions",
  },
  privacyPolicy: {
    id: "checkout.payment_form.privacyPolicy",
    description: "privacy policy",
    defaultMessage: "privacy policy",
  },
  confirm: {
    id: "checkout.payment_form.confirm",
    description: "confirm",
    defaultMessage: "Confirm Booking",
  },
  payAndConfirm: {
    id: "checkout.payment_form.payAndConfirm",
    description: "payAndConfirm",
    defaultMessage: "Pay and Confirm",
  },
  enterCard: {
    id: "checkout.payment_form.enterCard",
    description: "payAndConfirm",
    defaultMessage: "Add card",
  },
  pointOfSale: {
    id: "checkout.payment_form.pointOfSaleDescription",
    description: "TPV payment info message",
    defaultMessage:
      "Payment is made through a payment gateway and the following cards will be accepted",
  },
  paymentErrorMessage: {
    id: "payNoPainErrorMessage.genericError",
    description: "Any other error occured",
    defaultMessage: "The transaction could not be completed.",
  },
  tryAgain: {
    id: "payNoPainErrorMessage.tryAgain",
    description: "Try again message",
    defaultMessage: "Please Try Again.",
  },
  confirmText: {
    id: "checkout.payment_form.confirmText",
    description:
      "Try Before confirming, you should read the basic information about data protection that you can consult message",
    defaultMessage:
      "Before confirming, you should read the basic information about data protection that you can consult",
  },
  here: {
    id: "checkout.payment_form.here",
    description: "here",
    defaultMessage: "here",
  },
  checkFields: {
    id: "checkout.payment_form.checkFields",
    description: "Check the fields in red",
    defaultMessage: "Check the fields in red",
  },
  mustAgree: {
    id: "checkout.payment_form.mustAgree",
    description: "You must agree to terms and conditions",
    defaultMessage: "You must agree to terms and conditions",
  },
  paymentError: {
    id: "checkout.payment_form.paymentError",
    description: "Your payment can’t be completed.",
    defaultMessage: "Your payment can’t be completed.",
  },
  smartPaymentError: {
    id: "checkout.payment_form.addon.error1",
    description: "Your deferred payment can’t be completed.",
    defaultMessage: "Your deferred payment can’t be completed.",
  },
  timeLeft: {
    id: "deferred.timeLeft",
    description: "Time left",
    defaultMessage: "Time left",
  },
  payLater: {
    id: "checkout.payment_form.payLater",
    description: "Pay later",
    defaultMessage: "Pay later",
  },
  until: {
    id: "checkout.payment_form.until",
    description: "Until",
    defaultMessage: "Until",
  },
  agent: {
    id: "reservation_confirmed.reservation_detail.agent",
    description: "Agent",
    defaultMessage: "Agent",
  },
});

const StyledFinalCountdown = styled.span`
  color: ${wbRed};
  font-weight: 700;
  font-size: 14px;
`;

const FinalCountdownWrapper = styled.div`
  margin-bottom: 15px;
  margin-top: 15px;
`;

const PaymentDescription = styled.span`
  text-align: left;
`;

const AlignLeft = styled.div`
  text-align: left;
`;
function renderPaymentDescription(description) {
  return <PaymentDescription dangerouslySetInnerHTML={renderHTML(description)} />;
}

function isTokenPayment({ paymentTypeOption }) {
  return (
    paymentTypeOption === constants.PAYMENT_TYPES.PNP_TOKEN ||
    paymentTypeOption === constants.PAYMENT_TYPES.PAY_NO_PAIN_V2 ||
    paymentTypeOption === constants.PAYMENT_TYPES.PAY_NO_PAIN_PROXY ||
    paymentTypeOption === constants.PAYMENT_TYPES.SIPAY_TOKENIZED_VAULT ||
    paymentTypeOption === constants.PAYMENT_TYPES.STRIPE ||
    paymentTypeOption === constants.PAYMENT_TYPES.PCI_PROXY
  );
}

function CreditCardIcons({ creditCardTypes }) {
  return (
    <div className={classnames("wbkv9-OnlinePayment-creditCardIcons", styles.creditCardIcons)}>
      {creditCardTypes &&
        creditCardTypes.map((creditCard, idx) => (
          <div
            key={idx}
            className={classnames(
              "wbkv9-OnlinePayment-creditCardIconContainer",
              styles.creditCardIconContainer
            )}>
            <img src={creditCardIcons[creditCard]} alt={creditCard} />
          </div>
        ))}
    </div>
  );
}

function OnlinePayment({ creditCardTypes, description }) {
  const creditCardTypesLength = creditCardTypes && creditCardTypes.size;

  return (
    <div className={classnames("wbkv9-OnlinePayment", styles.pointOfSale)}>
      <AlignLeft>
        <CreditCardIcons creditCardTypes={creditCardTypes} />

        {description}
        {creditCardTypes && (
          <>
            :
            {creditCardTypes.map((creditCard, index) => {
              const separator = index >= creditCardTypesLength - 1 ? "." : ", ";
              return creditCard + separator;
            })}
          </>
        )}
      </AlignLeft>
    </div>
  );
}

function renderPaymentOptionContent({
  paymentTypeOption,
  fields,
  creditCardTypes,
  depositTotal,
  defaultDeposit,
  idReservation,
  handlePCIProxySubmit,
  pciProxyError,
  createPCIProxyError,
  propertyTicker,
  description: descriptionDefault,
  descriptionWithDeposit,
  descriptionWithoutDeposit,
  configurationParams,
  createPnPV2PaymentOrder,
  tokenizePnPV2Error,
  pnpV2PaymentToken,
  handleModalContent,
  handleCloseModal,
  createPnPV2PaymentOrderSuccess,
  createPnPV2PaymentOrderError,
  paymentTickerOption,
  expiration,
  attempt,
  inSmartPayment,
}) {
  let description = descriptionDefault;
  if (depositTotal && descriptionWithDeposit) {
    description = descriptionWithDeposit;
  } else if (!depositTotal && descriptionWithoutDeposit) {
    description = descriptionWithoutDeposit;
  }
  switch (paymentTypeOption) {
    case constants.PAYMENT_TYPES.PCI_PROXY:
      return (
        <PCIProxy
          fields={fields}
          propertyTicker={propertyTicker}
          creditCardTypes={creditCardTypes}
          depositTotal={depositTotal}
          idReservation={idReservation}
          handlePCIProxySubmit={handlePCIProxySubmit}
          pciProxyError={pciProxyError}
          createPCIProxyError={createPCIProxyError}
          description={renderPaymentDescription(description)}
          creditCardsList={<CreditCardIcons creditCardTypes={creditCardTypes} />}
        />
      );
    case constants.PAYMENT_TYPES.CREDIT_CARD_VAULT:
      return (
        <CCForm
          fields={fields}
          creditCardTypes={creditCardTypes}
          depositTotal={depositTotal}
          description={renderPaymentDescription(description)}
          creditCardsList={<CreditCardIcons creditCardTypes={creditCardTypes} />}
        />
      );
    case constants.PAYMENT_TYPES.CREDIT_CARD_VAULT_EMERGENT:
      return (
        <CCForm
          fields={fields}
          creditCardTypes={creditCardTypes}
          depositTotal={depositTotal}
          description={renderPaymentDescription(description)}
          creditCardsList={<CreditCardIcons creditCardTypes={creditCardTypes} />}
        />
      );
    case constants.PAYMENT_TYPES.CRIPTAN:
      return <OnlinePayment description={renderPaymentDescription(description)} />;
    case constants.PAYMENT_TYPES.ADDON_PAYMENTS:
    case constants.PAYMENT_TYPES.POS:
      return (
        <OnlinePayment
          creditCardTypes={creditCardTypes}
          description={renderPaymentDescription(description)}
        />
      );
    case constants.PAYMENT_TYPES.SIPAY_TOKENIZED_VAULT:
    case constants.PAYMENT_TYPES.PNP_TOKEN:
      if (isTokenPayment({ paymentTypeOption })) {
        if (depositTotal && depositTotal > 0) {
          return (
            <OnlinePayment
              creditCardTypes={creditCardTypes}
              description={renderPaymentDescription(description)}
            />
          );
        }
        return (
          <div className={styles.guaranteeMessageContainer}>
            <GuaranteeMessage
              depositTotal={depositTotal}
              description={renderPaymentDescription(description)}
              creditCardsList={<CreditCardIcons creditCardTypes={creditCardTypes} />}
            />
          </div>
        );
      }
      break;
    case constants.PAYMENT_TYPES.PAY_NO_PAIN_V2:
    case constants.PAYMENT_TYPES.PAY_NO_PAIN_PROXY:
      let chargeDeposit = true;
      if (configurationParams && configurationParams.get("chargeDeposit")) {
        chargeDeposit = configurationParams.get("chargeDeposit") === "true";
      }
      return (
        <PayNoPainV2BridgeWrapper
          fields={fields}
          propertyTicker={propertyTicker}
          creditCardTypes={creditCardTypes}
          description={renderPaymentDescription(description)}
          amount={defaultDeposit}
          idReservation={idReservation}
          service={configurationParams && configurationParams.get("service")}
          template={configurationParams && configurationParams.get("template")}
          chargeDeposit={chargeDeposit}
          createPnPV2PaymentOrder={createPnPV2PaymentOrder}
          tokenizePnPV2Error={tokenizePnPV2Error}
          pnpV2PaymentToken={pnpV2PaymentToken}
          handleModalContent={handleModalContent}
          handleCloseModal={handleCloseModal}
          createPnPV2PaymentOrderSuccess={createPnPV2PaymentOrderSuccess}
          createPnPV2PaymentOrderError={createPnPV2PaymentOrderError}
          paymentTicker={paymentTickerOption}
          creditCardsList={<CreditCardIcons creditCardTypes={creditCardTypes} />}
          attempt={attempt}
          inSmartPayment={inSmartPayment}
        />
      );
    case constants.PAYMENT_TYPES.STRIPE:
      if (isTokenPayment({ paymentTypeOption })) {
        if (depositTotal && depositTotal > 0) {
          return (
            <OnlinePayment
              creditCardTypes={creditCardTypes}
              description={renderPaymentDescription(description)}
            />
          );
        }
        return (
          <div className={styles.guaranteeMessageContainer}>
            <GuaranteeMessage
              depositTotal={depositTotal}
              description={renderPaymentDescription(description)}
              creditCardsList={<CreditCardIcons creditCardTypes={creditCardTypes} />}
            />
          </div>
        );
      }
      return (
        <div className={styles.wireTransfer}>
          Pay through Stripe
          {renderPaymentDescription(description)}
        </div>
      );
    case constants.PAYMENT_TYPES.DEFERRED:
      return <Deferred expiration={expiration} description={description} />;

    case constants.PAYMENT_TYPES.PAYPAL_EXPRESS_CHECKOUT:
    case constants.PAYMENT_TYPES.PAYPAL_EXPRESS_STANDARD:
    case constants.PAYMENT_TYPES.TRANSFER:
    case constants.PAYMENT_TYPES.WITHOUT_CARD:
    case constants.PAYMENT_TYPES.RESERVATION_REQUEST:
      return <div className={styles.wireTransfer}>{renderPaymentDescription(description)}</div>;

    default:
      return (
        <div className={"wbkv9" + paymentTypeOption}>{renderPaymentDescription(description)}</div>
      );
  }
}

function isFieldInvalid(fieldName, fields) {
  return fields[fieldName] && fields[fieldName].touched && fields[fieldName].error;
}

function hasInvalidField(fields, isCustomFormValid) {
  if (fields) {
    for (const field in fields) {
      if (fields[field].touched) {
        if (fields[field].invalid || isCustomFormValid === false) {
          return true;
        }
      }
    }
  }
  return false;
}

function ConfirmationButton({
  paymentType,
  depositTotal,
  invalid,
  submitting,
  loading,
  paypalButton,
  onSubmit,
  propertyTicker,
  touchOnSubmit,
  affiliateIsEncoded,
  affiliate,
  increaseAttempts,
}) {
  const [onCooldown, setOnCooldown] = useState(false);

  let buttonMessage = msgs.confirm;
  if (isTokenPayment({ paymentTypeOption: paymentType })) {
    if (depositTotal && depositTotal > 0) {
      buttonMessage = msgs.payAndConfirm;
    } else {
      buttonMessage = msgs.enterCard;
    }
  }
  if (paymentType === constants.PAYMENT_TYPES.POS) {
    buttonMessage = msgs.payAndConfirm;
  }
  if (paymentType === constants.PAYMENT_TYPES.PCI_PROXY) {
    buttonMessage = msgs.confirm;
  }
  const isPaypalButtonVisible =
    paymentType === constants.PAYMENT_TYPES.PAYPAL_EXPRESS_CHECKOUT ||
    paymentType === constants.PAYMENT_TYPES.PAYPAL_EXPRESS_STANDARD;

  const handleSubmitThrottle = useCallback(() => {
    if (typeof touchOnSubmit === "function") {
      touchOnSubmit();
    }
    // This is necessary so payment scripts like PNP get triggered at all
    setTimeout(function () {
      setOnCooldown(true);
      increaseAttempts();
    }, 0);
    // This is necessary so payment scripts like PNP wouldn't trigger more than
    // once on clicking the button several times during submission
    setTimeout(function () {
      setOnCooldown(false);
    }, 5000);
  }, [onCooldown, setOnCooldown]);
  return (
    <div
      className={classnames(
        "wbkv9-PaymentForm-confirmationButton",
        affiliateIsEncoded ? styles.buttonContainerSmall : styles.buttonContainer,
        (submitting || loading) && styles.disabled
      )}>
      <div className={classnames(styles.paypalButton, isPaypalButtonVisible && styles.active)}>
        {invalid && (
          <button
            className={classnames("wbkv9-PaymentForm-PayPalButtonGhost", styles.paypalButtonGhost)}
          />
        )}
        {paypalButton &&
          React.cloneElement(paypalButton, {
            onPayment: onSubmit,
            propertyTicker,
          })}
      </div>
      {!isPaypalButtonVisible && (
        <button disabled={onCooldown} onClick={handleSubmitThrottle}>
          <span>
            <Lock2Icon />
            <FormattedMessage {...buttonMessage} />
          </span>
          {affiliateIsEncoded && (
            <div>
              <FormattedMessage {...msgs.agent} />: {affiliate}
            </div>
          )}
        </button>
      )}
    </div>
  );
}

const StyledPaymentNameContainer = styled.div`
  display: flex;
  ${props => (props.isDeferred ? "justify-content: flex-start" : "align-items: center")};
  input {
    margin-top: ${props => (props.isDeferred ? "3px" : "0")};
  }
`;

const StyledDeferredUntilDate = styled.div`
  color: #908f96;
  font-size: 12px;
  font-weight: 400;
  text-transform: none;
`;

const StyledLockHoursDate = styled.span`
  display: inline-block;
`;

const DeferredPaymentTitle = ({ title, expiration }) => {
  let time = moment(expiration);
  if (expiration) {
    let daysDiff = moment(expiration).diff(moment());
    if (daysDiff <= 0) {
      time = moment();
    }
  }

  return (
    <>
      {title || <FormattedMessage {...msgs.payLater} />}
      <StyledDeferredUntilDate>
        <FormattedMessage {...msgs.until} />{" "}
        {expiration && (
          <StyledLockHoursDate>
            <FormattedDate value={time} year="numeric" month="long" day="2-digit" />
          </StyledLockHoursDate>
        )}
      </StyledDeferredUntilDate>
    </>
  );
};

function FinalCountdown({ deferredDeadline }) {
  const [timeLeft, setTimeLeft] = useState();

  useEffect(() => {
    if (deferredDeadline) {
      const interval = setInterval(() => {
        const time = moment
          .duration(moment(deferredDeadline) - moment())
          .format("d[d] h[h] m[m] s[s]");
        setTimeLeft(time);
        return () => clearInterval(interval);
      });
    }
  });
  return (
    <StyledFinalCountdown>
      <FormattedMessage {...msgs.timeLeft} />: {timeLeft}
    </StyledFinalCountdown>
  );
}

function PaymentOption({
  paymentTypeOption,
  onSelectPaymentType,
  fields,
  creditCardTypes,
  depositTotal,
  idReservation,
  handlePCIProxySubmit,
  pciProxyError,
  createPCIProxyError,
  propertyTicker,
  hideRadio,
  invalid,
  submitting,
  loading,
  paypalButton,
  onSubmit,
  handlePrivacyPolicy,
  currency,
  defaultCurrency,
  bookingTotalRate,
  cancelRelease,
  reservationStartDate,
  pendingAmount,
  depositAmount,
  defaultTotalAmount,
  isCustomFormValid,
  touchOnSubmit,
  selectedPayment,
  paymentTickerOption,
  actualPaymentType,
  createPnPV2PaymentOrder,
  tokenizePnPV2Error,
  paymentError,
  formAsyncValidationErrors,
  pnpV2PaymentToken,
  handleModalContent,
  handleCloseModal,
  createPnPV2PaymentOrderSuccess,
  createPnPV2PaymentOrderError,
  taxesText,
  inSmartPayment,
  expiration,
  smartPaymentError,
  deferredDeadline,
  affiliateIsEncoded,
  affiliate,
  reservations,
  cancellationRestrictions,
  cancellationPoliciesInfo,
  originalTotalTax,
  originalTotalCityTax,
}) {
  const [attempt, setAttempt] = useState(0);
  const increaseAttempts = useCallback(() => {
    return setAttempt(attempt + 1);
  }, [attempt, setAttempt]);
  const { invalid: _a, ...hasAcceptedConditionsProps } = fields.hasAcceptedConditions || {};
  const isPci =
    isTokenPayment({ paymentTypeOption }) ||
    paymentTypeOption === constants.PAYMENT_TYPES.POS ||
    paymentTypeOption === constants.PAYMENT_TYPES.PCI_PROXY ||
    paymentTypeOption === constants.PAYMENT_TYPES.STRIPE ||
    paymentTypeOption === constants.PAYMENT_TYPES.PAYPAL_EXPRESS_CHECKOUT ||
    paymentTypeOption === constants.PAYMENT_TYPES.TRANSFER ||
    paymentTypeOption === constants.PAYMENT_TYPES.WITHOUT_CARD ||
    paymentTypeOption === constants.PAYMENT_TYPES.RESERVATION_REQUEST ||
    paymentTypeOption === constants.PAYMENT_TYPES.DEFERRED;
  const description = actualPaymentType.get("description");
  const descriptionWithDeposit = actualPaymentType.get("descriptionWithDeposit");
  const descriptionWithoutDeposit = actualPaymentType.get("descriptionWithoutDeposit");

  const hasAsyncErrors =
    formAsyncValidationErrors && Object.keys(formAsyncValidationErrors).length > 0;

  const isDeferred = actualPaymentType.get("type") === constants.PAYMENT_TYPES.DEFERRED;

  const handleConditions = useCallback(() => {
    const conditionsList = reservations.map(reservation => {
      const condition = reservation.get("inventory").get("condition");
      return {
        conditions: condition,
        restrictions:
          cancellationRestrictions && cancellationRestrictions[0][condition.get("ticker")],
        cancellationPoliciesInfo:
          cancellationPoliciesInfo && cancellationPoliciesInfo[0][condition.get("ticker")],
        checkIn:
          typeof reservation.get("startDate") === "string"
            ? reservation.get("startDate")
            : moment(reservation.get("startDate")).format("YYYY-MM-DD"),
        checkOut:
          typeof reservation.get("endDate") === "string"
            ? reservation.get("endDate")
            : moment(reservation.get("endDate")).format("YYYY-MM-DD"),
        amount: reservation.get("totalRate"),
        name: reservation.get("inventory").get("accommodation").get("name"),
        currency: reservation.get("inventory").get("currency"),
        firstNightCost: reservation.get("firstNightCost"),
        cutOffDate: Date.now(),
        showCancellationTable: true,
      };
    });

    handleModalContent(
      <Conditions.PopupConditions
        closeWindow={handleCloseModal}
        conditionsList={conditionsList.toJS()}
      />,
      { hideCloseButton: true, modalWidth: "700px" }
    );
  }, [reservations, cancellationRestrictions, cancellationPoliciesInfo, handleCloseModal]);

  return (
    <div>
      <div
        className={classnames(
          "wbkv9-PaymentForm-paymentOption",
          styles.paymentOption,
          paymentTypeOption && styles.selected
        )}
        onClick={() => onSelectPaymentType(paymentTickerOption)}>
        <StyledPaymentNameContainer isDeferred={isDeferred}>
          {!hideRadio && (
            <input
              type="radio"
              name="selectedPaymentMethod"
              value={selectedPayment && selectedPayment.get(propertyTicker) === actualPaymentType}
              readOnly
              checked={selectedPayment && selectedPayment.get(propertyTicker) === actualPaymentType}
            />
          )}
          <div className={"wbkv9-PaymentOption-Title"}>
            {!isDeferred && actualPaymentType.get("name")}
            {isDeferred && (
              <DeferredPaymentTitle title={actualPaymentType.get("name")} expiration={expiration} />
            )}
          </div>
        </StyledPaymentNameContainer>
      </div>
      {selectedPayment &&
        selectedPayment.get(propertyTicker) &&
        selectedPayment.get(propertyTicker).get("ticker") === paymentTickerOption && (
          <div>
            <div
              className={classnames(
                "wbkv9-PaymentForm-paymentOptionContent",
                styles.paymentOptionContent
              )}>
              {inSmartPayment && deferredDeadline && (
                <FinalCountdownWrapper>
                  <FinalCountdown deferredDeadline={deferredDeadline} />
                </FinalCountdownWrapper>
              )}
              {renderPaymentOptionContent({
                paymentTypeOption,
                fields,
                creditCardTypes,
                defaultDeposit: depositAmount,
                depositTotal,
                idReservation,
                handlePCIProxySubmit,
                pciProxyError,
                createPCIProxyError,
                propertyTicker,
                description,
                descriptionWithDeposit,
                descriptionWithoutDeposit,
                configurationParams: actualPaymentType.get("configurationParams"),
                createPnPV2PaymentOrder,
                tokenizePnPV2Error,
                pnpV2PaymentToken,
                handleModalContent,
                handleCloseModal,
                createPnPV2PaymentOrderSuccess,
                createPnPV2PaymentOrderError,
                paymentTickerOption,
                expiration,
                attempt,
                inSmartPayment,
              })}
            </div>
            <ReservationTotalAmount
              currency={currency}
              defaultCurrency={defaultCurrency}
              totalAmount={bookingTotalRate}
              pending={pendingAmount}
              deposit={depositAmount}
              cancelRelease={cancelRelease}
              reservationStartDate={reservationStartDate}
              defaultTotalAmount={defaultTotalAmount}
              taxesText={taxesText}
              inPaymentForm
              originalTotalTax={originalTotalTax}
              originalTotalCityTax={originalTotalCityTax}
            />

            <div
              className={classnames(
                "wbkv9-PaymentForm-tc-Button-PaymentOptions",
                styles.tcButtonPaymentOptions
              )}>
              <div
                className={classnames(
                  "wbkv9-PaymentForm-termsAndConditions",
                  styles.termsAndConditions,
                  isFieldInvalid("hasAcceptedConditions", fields) && styles.invalidTC
                )}>
                <div
                  className={classnames(
                    "wbkv9-PaymentForm-termsAndConditionsContainer",
                    styles.termsAndConditionsContainer
                  )}>
                  <input type="checkbox" {...hasAcceptedConditionsProps} />

                  <div>
                    <a className={styles.acceptTerms} onClick={handleConditions}>
                      <FormattedMessage {...msgs.termsAndConditions} />
                    </a>
                    {", "}
                    <a
                      className={classnames(styles.acceptTerms, styles.privacyPolicy)}
                      onClick={() => handlePrivacyPolicy(false)}>
                      <FormattedMessage {...msgs.privacyPolicy} />
                    </a>
                  </div>
                </div>
              </div>
              {(isFieldInvalid("hasAcceptedConditions", fields) && (
                <div
                  className={classnames(
                    "wbkv9-PaymentForm-InvalidFieldMessage",
                    styles.InvalidFieldMessage
                  )}>
                  <FormattedMessage {...msgs.mustAgree} />
                </div>
              )) ||
                ((hasInvalidField(fields, isCustomFormValid) || hasAsyncErrors) && (
                  <div
                    className={classnames(
                      "wbkv9-PaymentForm-InvalidFieldMessage",
                      styles.InvalidFieldMessage
                    )}>
                    <FormattedMessage {...msgs.checkFields} />
                  </div>
                ))}

              {paymentError && (
                <div
                  className={classnames(
                    "wbkv9-PaymentForm-InvalidFieldMessage",
                    styles.InvalidFieldMessage
                  )}>
                  <FormattedMessage {...msgs.paymentError} />
                </div>
              )}

              {smartPaymentError && (
                <div
                  className={classnames(
                    "wbkv9-PaymentForm-InvalidFieldMessage",
                    styles.InvalidFieldMessage
                  )}>
                  <FormattedMessage {...msgs.smartPaymentError} />
                </div>
              )}
              <ConfirmationButton
                depositTotal={depositTotal}
                paymentType={paymentTypeOption}
                invalid={invalid}
                submitting={submitting}
                loading={loading}
                onSubmit={onSubmit}
                paypalButton={paypalButton}
                propertyTicker={propertyTicker}
                touchOnSubmit={touchOnSubmit}
                affiliateIsEncoded={affiliateIsEncoded}
                affiliate={affiliate}
                increaseAttempts={increaseAttempts}
              />
              <div
                className={classnames(
                  "wbkv9-PaymentForm-paymentOptionIcons",
                  styles.paymentOptionIcons
                )}>
                <img
                  className={classnames(
                    "wbkv9-PaymentForm-paymentOptionIcon-Comodo",
                    styles.comodo
                  )}
                  src={comodoSecureURL}
                />
                {isPci && (
                  <img
                    className={classnames("wbkv9-PaymentForm-paymentOptionIcon-PCI", styles.pci)}
                    src={pciURL}
                  />
                )}
              </div>
            </div>
          </div>
        )}
    </div>
  );
}

function PaymentForm({
  fields,
  creditCardTypes,
  messages,
  invalid,
  submitting,
  loading,
  onSelectPaymentType,
  handleConditions,
  depositTotal,
  paypalButton,
  onSubmit,
  idReservation,
  privacyPolicy,
  propertyName,
  handlePCIProxySubmit,
  pciProxyError,
  createPCIProxyError,
  propertyTicker,
  handleModalContent,
  handleCloseModal,
  reservationStartDate,
  cancelRelease,
  currency,
  defaultCurrency,
  pendingAmount,
  depositAmount,
  bookingTotalRate,
  defaultTotalAmount,
  isCustomFormValid,
  locale,
  touchOnSubmit,
  selectedPayment,
  availablePayments,
  hideDefaultPrivacyPolicy,
  createPnPV2PaymentOrder,
  tokenizePnPV2Error,
  paymentError,
  formAsyncValidationErrors,
  pnpV2PaymentToken,
  createPnPV2PaymentOrderSuccess,
  createPnPV2PaymentOrderError,
  taxesText,
  className,
  inSmartPayment,
  expiration,
  smartPaymentError,
  deferredDeadline,
  affiliateIsEncoded,
  affiliate,
  reservations,
  cancellationRestrictions,
  cancellationPoliciesInfo,
  originalTotalTax,
  originalTotalCityTax,
}) {
  const handlePrivacyPolicy = reverse => {
    handleModalContent(
      <div>
        <PopupPrivacy
          data={{ propertyName, reverse, privacyPolicy }}
          locale={locale}
          closeWindow={handleCloseModal}
          hideDefaultPrivacyPolicy={hideDefaultPrivacyPolicy}
        />
      </div>,
      {
        hideCloseButton: true,
        modalWidth: "700px",
      }
    );
  };
  return (
    <div className={classnames("wbkv9-PaymentForm", styles.paymentFormContainer, className)}>
      <div className={classnames("wbkv9-PaymentForm-title", styles.title)}>
        <FormattedMessage {...msgs.paymentOptions} />
      </div>
      {messages
        ? messages.map((el, index) => (
            <Notification
              key={index}
              id={el.get("id")}
              position={el.get("position")}
              text={<span dangerouslySetInnerHTML={renderHTML(el.get("content"))} />}
              type={el.get("type").toLowerCase()}
              propertyTicker={propertyTicker}
              hideIcon
            />
          ))
        : false}
      <div className={styles.innerContainer}>
        <div className={classnames("wbkv9-PaymentForm-paymentOptions", styles.paymentOptions)}>
          {availablePayments &&
            availablePayments.filter(
              availablePayment =>
                availablePayment.get("properties") &&
                availablePayment.get("properties").get("expiration") &&
                moment().isBefore(availablePayment.get("properties").get("expiration"))
            ) &&
            availablePayments.map((availablePayment, index) => {
              return (
                <PaymentOption
                  key={index}
                  createPCIProxyError={createPCIProxyError}
                  handlePCIProxySubmit={handlePCIProxySubmit}
                  pciProxyError={pciProxyError}
                  paymentTypeOption={availablePayment.get("type")}
                  paymentTickerOption={availablePayment.get("ticker")}
                  actualPaymentType={availablePayments.get(index)}
                  onSelectPaymentType={onSelectPaymentType}
                  fields={fields}
                  creditCardTypes={creditCardTypes}
                  depositTotal={depositTotal}
                  idReservation={idReservation}
                  propertyTicker={propertyTicker}
                  hideRadio={availablePayments.size === 1}
                  invalid={invalid}
                  submitting={submitting}
                  loading={loading}
                  paypalButton={paypalButton}
                  onSubmit={onSubmit}
                  handleConditions={handleConditions}
                  handlePrivacyPolicy={handlePrivacyPolicy}
                  reservationStartDate={reservationStartDate}
                  cancelRelease={cancelRelease}
                  currency={currency}
                  defaultCurrency={defaultCurrency}
                  pendingAmount={pendingAmount}
                  depositAmount={depositAmount}
                  bookingTotalRate={bookingTotalRate}
                  defaultTotalAmount={defaultTotalAmount}
                  isCustomFormValid={isCustomFormValid}
                  touchOnSubmit={touchOnSubmit}
                  selectedPayment={selectedPayment}
                  createPnPV2PaymentOrder={createPnPV2PaymentOrder}
                  tokenizePnPV2Error={tokenizePnPV2Error}
                  paymentError={paymentError}
                  formAsyncValidationErrors={formAsyncValidationErrors}
                  pnpV2PaymentToken={pnpV2PaymentToken}
                  handleModalContent={handleModalContent}
                  handleCloseModal={handleCloseModal}
                  createPnPV2PaymentOrderSuccess={createPnPV2PaymentOrderSuccess}
                  createPnPV2PaymentOrderError={createPnPV2PaymentOrderError}
                  taxesText={taxesText}
                  inSmartPayment={inSmartPayment}
                  expiration={expiration}
                  smartPaymentError={smartPaymentError}
                  deferredDeadline={deferredDeadline}
                  affiliateIsEncoded={affiliateIsEncoded}
                  affiliate={affiliate}
                  reservations={reservations}
                  cancellationRestrictions={cancellationRestrictions}
                  cancellationPoliciesInfo={cancellationPoliciesInfo}
                  originalTotalTax={originalTotalTax}
                  originalTotalCityTax={originalTotalCityTax}
                />
              );
            })}
        </div>
      </div>
      <div
        className={classnames(
          "wbkv9-PaymentForm-privacyPolicyPreview",
          styles.privacyPolicyPreview
        )}>
        <FormattedMessage {...msgs.confirmText} />{" "}
        <a
          className={classnames(
            "wbkv9-PaymentForm-privacyPolicyPreviewLink",
            styles.privacyPolicyPreviewLink
          )}
          onClick={() => handlePrivacyPolicy(true)}>
          <FormattedMessage {...msgs.here} />
        </a>
      </div>
    </div>
  );
}

//TODO: Correct proptypes
// PaymentForm.propTypes = {
//   paymentTypes: PropTypes.array,
//   idReservation: PropTypes.string
// };

export default pure(PaymentForm);
